var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import React from "react";
import { Box, Heading, Paragraph, ResponsiveContext } from "grommet";
import styled from "styled-components";
import { isMobileTabletResponsive } from "../../../utils/utils";
var StyledLink = styled.a(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.7;\n  }\n",
    ]))
);
export var SmallImage = function SmallImage(_ref) {
  var image = _ref.image,
    heading = _ref.heading,
    publication_date = _ref.publication_date,
    link = _ref.link,
    as = _ref.as;
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(ResponsiveContext.Consumer, null, function (size) {
      return /*#__PURE__*/ React.createElement(
        Box,
        {
          width: {
            max: isMobileTabletResponsive(size) ? "" : "330px",
          },
          height: "220px",
          round: "20px",
          background: {
            image:
              "linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8)), url(" + image + ")",
            size: "cover",
          },
        },
        /*#__PURE__*/ React.createElement(
          Box,
          {
            flex: true,
            pad: "medium",
          },
          /*#__PURE__*/ React.createElement(
            Paragraph,
            {
              size: "0.75rem",
              color: "white",
            },
            publication_date
          ),
          /*#__PURE__*/ React.createElement(
            Box,
            {
              flex: true,
              justify: "end",
            },
            /*#__PURE__*/ React.createElement(
              StyledLink,
              {
                as: as,
                to: link,
                style: {
                  textDecoration: "none",
                },
              },
              /*#__PURE__*/ React.createElement(
                Heading,
                {
                  size: "1.125rem",
                  color: "white",
                },
                heading
              )
            )
          )
        )
      );
    })
  );
};
